import { useState, useEffect, useContext } from 'react';

// Nucleus Components
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useLazyDataModel } from '@thd-nucleus/data-sources';

import { updateReservation } from '../utils/api';
import { ReservationContext } from '../context/reservation-context';
import { convertYearMonthDay } from '../utils/mapper';
import { SUBMIT_RENTAL_RESERVATION_MODIFICATION_QUERY } from '../utils/queries';

export const useReservationUpdateApi = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [isExecutable, setIsExecutable] = useState(true);

  const [reservationState, dispatch] = useContext(ReservationContext);
  const {
    reservationId,
    uuid,
    selectedAvailability: {
      start,
      end
    }
  } = reservationState;
  // graphQlEnabled is always false at the moment while we fix the service submitRentalReservationModification
  const graphQlEnabled = false;

  const ctx = useContext(ExperienceContext);
  const { hosts } = ctx;
  const { apionline } = hosts || {};

  const variables = {
    reservationId: +reservationId,
    user_id: 'Rent Online',
    pickup_time: convertYearMonthDay(start),
    return_time: convertYearMonthDay(end),
    uuid
  };
  const [submitRentalReservationModification] = useLazyDataModel('submitRentalReservationModification', {
    variables,
    ssr: false,
  });

  const executeRequest = async () => {

    if (isExecutable) {
      setLoading(true);
      setIsExecutable(false);
      setError('');
      try {
        let result = null;

        if (graphQlEnabled) {
          const {
            data: rentalReservationData,
            error: rentalReservationError
          } = await submitRentalReservationModification({ variables });

          if (rentalReservationError) {
            throw new Error(rentalReservationError);
          }
          result = rentalReservationData.submitRentalReservationModification;
        } else {
          result = await updateReservation({
            host: apionline,
            reservationId,
            start,
            end,
            uuid
          });
        }

        setData(result);
      } catch (err) {
        setError(err.message || 'Unexpected Error');
        setData({});
        setIsExecutable(true);
      } finally {
        setLoading(false);
      }
    } else {
      setData({ ...data });
    }
  };

  useEffect(() => {
    if (!isExecutable) {
      setIsExecutable(true);
      setData({});
      setError('');
    }
  }, [reservationId]);

  return {
    data,
    error,
    loading,
    executeRequest
  };
};

useReservationUpdateApi.dataModel = SUBMIT_RENTAL_RESERVATION_MODIFICATION_QUERY;